export const colors = {
    black: '#000000',
    white: '#FFFFFF',
    grey: {
        100: '#FBFBFB',
        300: '#E4E4E4',
        500: '#999999',
        600: '#666666',
        800: '#333333',
    },
    
    purple: {
        100: '#F0E3FD',
        200: '#CFABFA',
        300: '#AE7FF0',
        400: '#8F5DE2',
        500: '#652DD0',
        600: '#4D20B2',
        700: '#391695',
        800: '#270E78',
    },
    orange: {
        100: '#FEF2DA',
        200: '#FDE3B6',
        300: '#F9CD90',
        400: '#F3B773',
        500: '#EB8C47',
        600: '#CA7433',
        700: '#A95623',
        800: '#883B16',
        contrast: '#E7731E',
    },
    blue: {
        400: '#1976D2',
    },
};

export const font = {
    assistant: 'Assistant',
};

export const size = {
    mobile: '320px',
    tablet: '768px',
    laptop: '1024px',
};

export const device = {
    mobile: `(min-width: ${size.mobile})`,
    tablet: `(min-width: ${size.tablet})`,
    laptop: `(min-width: ${size.laptop})`,
};
